export default [
  {
    position: "absolute",
    top: 23,
    left: 39.5,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "firstDayChecklist.persona1.mTitleOne",
    mBody: "firstDayChecklist.persona1.mBodyOne",
    id: "OB_FirstDay_Info_Personalization",
    infoIcon: true,
    isAction: false,
    index: 0,
  },
  {
    position: "absolute",
    top: 23,
    left: 9.5,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "firstDayChecklist.persona1.mTitleTwo",
    mBody: "firstDayChecklist.persona1.mBodyTwo",
    isVideo: true,
    videoThumb: "OB-FDC-Thumb",
    videoURL: "OB-First-Day-Checklist.mp4",
    vidIcon: true,
    id: "OB_FirstDay_Video_Tracking",
    index: 1,
  },
  {
    position: "absolute",
    top: 9.7,
    left: 5.5,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "firstDayChecklist.persona1.ttTextOne",
    hover: false,
    id: "OB_FirstDay_Navigation_Homepage",
    index: 2,
  },
  {
    position: "absolute",
    top: 6.8,
    left: 32.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "firstDayChecklist.persona1.ttTextTwo",
    hover: false,
    id: "OB_FirstDay_Navigation_PersonalDetails",
    index: 3,
  },
  {
    position: "absolute",
    top: 6.8,
    left: 60.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 4,
    tooltipText: "firstDayChecklist.persona1.ttTextThree",
    hover: false,
    id: "OB_FirstDay_Navigation_Policies",
    index: 4,
  },
  {
    position: "absolute",
    top: 6.8,
    left: 69.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 5,
    tooltipText: "firstDayChecklist.persona1.ttTextFour",
    hover: false,
    id: "OB_FirstDay_Navigation_Feedback",
    index: 5,
  },
  {
    position: "absolute",
    top: 1,
    left: 87,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 8,
    tooltipText: "firstDayChecklist.persona1.ttTextFive",
    hover: false,
    tooltipClass: "left",
    id: "OB_FirstDay_Navigation_Actions",
    index: 6,
  },
];
